import BrandsAdd from "./BrandsAdd";

export default BrandsAdd;
